module.exports = __webpack_public_path__ + "static/img/bg12.bf8ce7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/bg12.png
// module id = By2G
// module chunks = 1